{
  "page": {
    "title": "Bo'lim sozlamasi",
    "loading": "Yuklanmoqda…",
    "loadError": "Bo'lim ma'lumotlarini yuklab bo'lmadi",
    "folderError": "Papka hujjatini yuklab bo'lmadi",
    "notFound": "Bo'lim topilmadi yoki o'chirilgan",
    "retry": "Qayta urinish"
  },
  "mode": {
    "label": "Bo'lim rejimi",
    "drawing": "Chizma",
    "3d": "3D"
  },
  "actions": {
    "preview": "Ko’rish",
    "save": "Saqlash",
    "saveHint": "Saqlash (Ctrl+S)",
    "cancel": "Bekor qilish",
    "delete": "O'chirish"
  },
  "save": {
    "success": "Saqlandi",
    "successHint": "O'zgarishlar barcha foydalanuvchilarga ko'rinadi",
    "error": "Saqlab bo'lmadi",
    "errorHint": "Ulanishni tekshirib, qayta urinib ko'ring"
  },
  "conflict": {
    "title": "Sahifa boshqa foydalanuvchi tomonidan o'zgartirilgan",
    "text": "Hujjatning yangi versiyasi saqlangan. Uni yuklab oling yoki o'zgarishlaringizni ustiga yozing.",
    "textBy": "{{name}} soat {{time}} da yangi versiyani saqladi. Uni yuklab oling yoki o'zgarishlaringizni ustiga yozing.",
    "reload": "Qayta yuklash",
    "overwrite": "Ustiga yozish",
    "cancel": "Bekor qilish",
    "reloaded": "Hujjatning so'nggi versiyasi yuklandi"
  },
  "guard": {
    "title": "Saqlanmagan o'zgarishlar bor. Chiqasizmi?",
    "text": "Saqlamasdan chiqsangiz, kiritilgan o'zgarishlar yo'qoladi.",
    "stay": "Bekor qilish",
    "discard": "Saqlamasdan chiqish",
    "save": "Saqlash"
  },
  "panel": {
    "close": "Yopish",
    "drag": "Sudrab ko'chirish"
  },
  "slider": {
    "decrease": "kamaytirish",
    "increase": "oshirish"
  },
  "folders": {
    "label": "Papkalar",
    "add": "Qo'shish",
    "createTitle": "Yangi modifikasiya qo’shish",
    "renameTitle": "Modifikasiyani tahrirlash",
    "subtitle": "Chizma uchun yangi modifikasiya qo'shish",
    "nameLabel": "Modifikasiya nomi",
    "namePlaceholder": "883.60",
    "continue": "Davom etish",
    "created": "“{{name}}” modifikasiyasi qo'shildi",
    "renamed": "Modifikasiya nomi o'zgartirildi",
    "deleted": "“{{name}}” o'chirildi",
    "deleteTitle": "Modifikasiyani o'chirish",
    "deleteText": "“{{name}}” va undagi chizma hamda ko'rsatkichlar o'chiriladi.",
    "deleteError": "Modifikasiyani o'chirib bo'lmadi",
    "defaultNoDelete": "Asosiy papkani o'chirib bo'lmaydi",
    "limit": "Papkalar soni chegarasiga yetildi ({{max}})",
    "unsaved": "Saqlanmagan o'zgarishlar bor",
    "pinCount_one": "{{count}} ta ko'rsatkich",
    "pinCount_other": "{{count}} ta ko'rsatkich",
    "menu": {
      "rename": "Tahrirlash",
      "replace": "Almashtirish",
      "delete": "O’chirish"
    },
    "errors": {
      "required": "Modifikasiya nomini kiriting",
      "tooLong": "Nom {{max}} belgidan oshmasin",
      "taken": "Bunday nomli papka mavjud",
      "generic": "Saqlab bo'lmadi"
    }
  },
  "rail": {
    "label": "Qatlamlar",
    "drawing": "Chizma",
    "deviceInfo": "Qurilma ma'lumoti",
    "data": "Ma'lumotlar bazasi",
    "table": "Jadval",
    "state": {
      "uploaded": "yuklangan",
      "notUploaded": "yuklanmagan",
      "enabled": "yoqilgan",
      "disabled": "o'chirilgan",
      "configured": "sozlangan",
      "notConfigured": "sozlanmagan"
    }
  },
  "canvas": {
    "label": "Chizma maydoni",
    "drawing": "Chizma va ko'rsatkichlar",
    "roleDescription": "chizma muharriri",
    "emptyTitle": "Chizma yuklanmagan",
    "emptyText": "Boshlash uchun shu papkaga chizma faylini yuklang.",
    "upload": "Chizma yuklash",
    "placingHint": "Chizmadan joy tanlang (bekor qilish: Esc)",
    "zoomIn": "Kattalashtirish",
    "zoomOut": "Kichiklashtirish",
    "fit": "Sig'dirish (100%)",
    "dropHere": "Chizma faylini shu yerga tashlang"
  },
  "drawing": {
    "emptyTitle": "Chizma yuklanmagan",
    "emptyText": "Hali chizma yo'q. \"Chizma yuklash\" tugmasini bosib SVG, PNG yoki DWG fayl tanlang.",
    "opacity": "Shaffoflik",
    "scale": "Masshtab",
    "replace": "Chizmani almashtirish",
    "delete": "Chizmani o'chirish",
    "deleteTitle": "Chizmani o'chirish",
    "deleteText": "Chizma papkadan olib tashlanadi. Ko'rsatkichlar joyida qoladi va yangi chizma yuklanganda ko'rinadi.",
    "deletePinsToo_one": "Ko'rsatkichni ham o'chirish ({{count}} ta)",
    "deletePinsToo_other": "Ko'rsatkichlarni ham o'chirish ({{count}} ta)",
    "uploading": "Yuklanmoqda… {{progress}}%",
    "uploaded": "Chizma yuklandi",
    "replaced": "Chizma almashtirildi",
    "saveHint": "O'zgarishlarni saqlashni unutmang",
    "uploadError": "Faylni o'qib bo'lmadi",
    "typeError": "Bu turdagi fayl qabul qilinmaydi",
    "sizeError": "Fayl hajmi juda katta",
    "formats": "SVG, PNG, JPG yoki WEBP · 50 MB gacha",
    "dwgTitle": "DWG konvertatsiyasi hozircha mavjud emas",
    "dwgText": "Chizmani SVG yoki PNG formatiga eksport qilib yuklang.",
    "aspectChanged": "Chizma nisbati o'zgardi — ko'rsatkichlar joylashuvini tekshiring"
  },
  "pins": {
    "title": "Ko’rsatkichlar",
    "add": "Ko’rsatkich qo’shish",
    "cancelPlacing": "Joy tanlashni bekor qilish",
    "emptyTitle": "Ko’rsatkichlar mavjud emas",
    "emptyText": "Hali Ko’rsatkich yo'q. \"Ko’rsatkich qo'shish\" tugmasini bosib chizmadan joy tanlang.",
    "needDrawing": "Avval chizma yuklang",
    "needDrawingHint": "Ko'rsatkichlar chizma ustiga joylashtiriladi",
    "limit": "Ko'rsatkichlar soni chegarasiga yetildi ({{max}})",
    "untitled": "Yangi ko'rsatkich",
    "noDevice": "Qurilma tanlanmagan",
    "rows_one": "{{count}} ko'rsatkich",
    "rows_other": "{{count}} ko'rsatkich",
    "show": "{{name}} — ko'rinadigan qilish",
    "hide": "{{name}} — yashirish",
    "hiddenHint": "Ko'rish sahifasida yashirilgan",
    "visibleHint": "Ko'rish sahifasida ko'rinadi",
    "settings": "{{name}} sozlamalari",
    "delete": "{{name}} — o'chirish"
  },
  "pin": {
    "back": "Ortga qaytish",
    "title": "Qurilma sozlamalari",
    "device": "QURILMA",
    "devicePlaceholder": "Qurilmani tanlang",
    "dynamic": "Dinamik - qurilmadan keladi: {{value}}",
    "rows": "QATORLAR (NOM = QIYMAT)",
    "rowName": "{{index}}-qator nomi",
    "rowNamePlaceholder": "Nom ({{suffix}})",
    "rowNamePlain": "Nom",
    "rowSource": "{{index}}-qator qiymati manbai",
    "rowValue": "{{index}}-qator qiymati",
    "rowValuePlaceholder": "Qiymat (0.45 mm)",
    "removeRow": "{{index}}-qatorni o'chirish",
    "manual": "Qo'lda kiritish...",
    "addRow": "Qator qo'shish",
    "rowsLimit": "Ko'pi bilan {{max}} ta qator",
    "rowsHint": "Qiymatni qurilma ko'rsatkichidan tanlang yoki qo'lda yozing.",
    "addSensorRow": "Qurilma",
    "labelPlacement": "YOZUV JOYLASHUVI",
    "side": {
      "top": "Yuqorida",
      "right": "O'ngda",
      "bottom": "Pastda",
      "left": "Chapda"
    },
    "distance": "NUQTADAN MASOFA",
    "offsetVertical": "YUQORIGA / PASTGA SILJITISH",
    "offsetHorizontal": "CHAPGA / O'NGGA SILJITISH",
    "hint": "Nuqta joyida qoladi - faqat yozuv kartasi siljiydi. Nuqta o'lchami o'zgarmaydi.",
    "delete": "Qurilmani o'chirish",
    "deleteTitle": "Qurilmani o'chirish",
    "deleteText": "“{{code}}” chizmadan va 3D modeldan olib tashlanadi.",
    "deleted": "“{{code}}” o'chirildi",
    "undoHint": "Bekor qilish: Ctrl+Z"
  },
  "picker": {
    "placeholder": "Tanlang",
    "search": "Qurilma yoki ko'rsatkich qidirish",
    "loading": "Qurilmalar yuklanmoqda…",
    "empty": "Hech narsa topilmadi",
    "missing": "Qurilma topilmadi",
    "otherCategory": "Boshqa qurilmalar"
  },
  "layers": {
    "showInViewer": "Ko'rish sahifasida ko'rsatish"
  },
  "deviceInfo": {
    "title": "Qurilma haqida ma'lumot",
    "enabledHint": "Yoqilgan - \"Qurilma haqida ma'lumot\" tugmasi chiqadi",
    "disabledHint": "O'chirilgan - ko'rish sahifasida ko'rinmaydi",
    "name": "Nom",
    "namePlaceholder": "Qurilma nomini kiriting",
    "media": "Rasm va video",
    "mediaTitle": "Rasm yoki video yuklang",
    "mediaHint": "JPG, PNG, MP4 · 50 MB gacha",
    "addMedia": "Rasm yoki video qo'shish",
    "removeMedia": "{{name}} — olib tashlash",
    "cover": "muqova",
    "mediaLimit": "Ko'pi bilan {{max}} ta rasm yoki video",
    "typeError": "Faqat JPG, PNG, WEBP rasm yoki MP4, WEBM video",
    "sizeError": "Fayl hajmi 50 MB dan oshmasin",
    "uploadError": "Faylni yuklab bo'lmadi",
    "collage": "Kollaj uslubi",
    "grid": "Setka",
    "mosaic": "Mozaika",
    "carousel": "Lenta",
    "collagePreview": "Kollaj ko'rinishi",
    "previous": "Oldingi",
    "next": "Keyingi",
    "description": "Ta'rif",
    "editorName": "Professional muharrir",
    "descriptionPlaceholder": "Qurilma haqida batafsil yozing…",
    "textEmpty": "Matn bo'sh",
    "textBlocks_one": "Matn · {{count}} band",
    "textBlocks_other": "Matn · {{count}} band",
    "limitReached": "Matn {{max}} belgidan oshmasin",
    "linkInvalid": "Havola noto'g'ri (http, https, mailto yoki tel)",
    "pdf": "PDF yuklab olish",
    "pdfOff": "O'chirilgan - yoqilsa PDF tugmasi chiqadi",
    "pdfOn": "Yoqilgan - foydalanuvchi PDF yuklab oladi"
  },
  "rte": {
    "toolbar": "Matn formatlash",
    "blockType": "Blok turi",
    "size": "Matn o'lchami",
    "paragraph": "Paragraf",
    "heading1": "Sarlavha 1",
    "heading2": "Sarlavha 2",
    "quote": "Iqtibos",
    "codeBlock": "Kod bloki",
    "undo": "Ortga",
    "redo": "Qaytarish",
    "bold": "Qalin",
    "italic": "Kursiv",
    "underline": "Tagiga chizilgan",
    "color": "Matn rangi",
    "bullets": "Belgili ro'yxat",
    "numbers": "Raqamli ro'yxat",
    "checklist": "Vazifalar ro'yxati",
    "link": "Havola",
    "linkUrl": "Havola manzili",
    "applyLink": "Qo'shish",
    "unlink": "Olib tashlash",
    "alignLeft": "Chapga",
    "alignCenter": "Markazga",
    "alignRight": "O'ngga",
    "alignJustify": "Kenglik bo'yicha",
    "table": "Jadval qo'shish",
    "image": "Rasm qo'shish",
    "code": "Kod",
    "clear": "Formatni tozalash"
  },
  "data": {
    "enabledHint": "Yoqilgan - \"Qurilma grafigi\" paneli chiqadi",
    "disabledHint": "O'chirilgan - ko'rish sahifasida ko'rinmaydi",
    "name": "Sarlavha",
    "namePlaceholder": "Qurilma grafigi",
    "series": "Qurilmalar",
    "addSeries": "Qurilma qo'shish",
    "seriesLimit": "Ko'pi bilan {{max}} ta qurilma",
    "removeSeries": "{{name}} — olib tashlash",
    "color": "Chiziq rangi",
    "axis": "O'q",
    "left": "Chap",
    "right": "O'ng",
    "range": "Standart davr",
    "range1d": "1 KUN",
    "range7d": "7 KUN",
    "range30d": "30 KUN",
    "rangeAll": "Barchasi",
    "view": "Ko'rinish",
    "viewChart": "Grafik holatida",
    "viewTable": "Jadval holatida",
    "thresholds": "Chegaralar",
    "thresholdLabel": "Chegara nomi",
    "thresholdLabelPlaceholder": "Ogohlantirish 25 °C",
    "thresholdValue": "Qiymat",
    "thresholdKind": "Chegara turi",
    "warning": "Ogohl.",
    "danger": "Xavf",
    "addThreshold": "Chegara qo'shish",
    "removeThreshold": "Chegarani o'chirish"
  },
  "tableLayer": {
    "enabledHint": "Yoqilgan - \"Jadval\" paneli chiqadi",
    "disabledHint": "O'chirilgan - ko'rish sahifasida ko'rinmaydi",
    "name": "Sarlavha",
    "namePlaceholder": "Jadval",
    "mode": "Jadval turi",
    "deviceList": "Qurilmalar ro'yxati",
    "custom": "Maxsus jadval",
    "deviceListHint_one": "Chizmadagi qurilmalarning ko'rsatkichlari avtomatik ro'yxatlanadi · hozir {{count}} ta qator.",
    "deviceListHint_other": "Chizmadagi qurilmalarning ko'rsatkichlari avtomatik ro'yxatlanadi · hozir {{count}} ta qator.",
    "openConstructor": "Jadval konstruktori"
  },
  "table": {
    "title": "Jadval konstruktori",
    "fullscreen": "To'liq ekran",
    "exitFullscreen": "To'liq ekrandan chiqish",
    "name": "Jadval nomi",
    "namePlaceholder": "Stvol bo'yicha monitoring",
    "untitled": "Nomsiz jadval",
    "columnsAndRows": "Ustunlar va qatorlar",
    "columns": "Ustunlar (stvol)",
    "columnsRange": "{{min}} dan {{max}} gacha",
    "addColumn": "Ustun qo'shish",
    "removeColumn": "Ustunni olib tashlash",
    "rows": "Qatorlar",
    "noRows": "Qatorlar yo'q",
    "count": {
      "manual": "qo'lda {{n}}",
      "device": "qurilma {{n}}",
      "formula": "formula {{n}}",
      "status": "holat {{n}}"
    },
    "addRow": "Qator qo'shish",
    "addRowHint": "Turini bosing - qator darhol qo'shiladi",
    "rowType": {
      "manual": "Qo'lda",
      "device": "Qurilma",
      "formula": "Formula",
      "status": "Holat"
    },
    "defaultRowName": "Qator {{n}}",
    "rowLimit": "Ko'pi bilan {{max}} ta qator",
    "formula": "Formula",
    "formulaPlaceholder": "Katak tanlanmagan - formula yoki qiymat",
    "usesRowFormula": "Qator formulasi: {{formula}}",
    "statusAuto": "Holat katagi avtomatik hisoblanadi",
    "pickSensor": "Katak uchun ko'rsatkichni tanlang",
    "grid": "Jadval",
    "size": "{{rows}} qator · {{cols}} ustun",
    "cornerLabel": "Stvor raqami",
    "columnLabel": "{{index}}-ustun nomi",
    "editCell": "Katak qiymati",
    "emptyRows": "Qator qo'shish uchun yuqoridagi tugmalardan birini bosing",
    "untitledRow": "Nomsiz qator",
    "formulaError": "Xato",
    "settings": "Sozlamalar",
    "rowSettingsTab": "Qator sozlamalari",
    "statusesTab": "Statuslar",
    "discardTitle": "Jadvaldagi o'zgarishlar saqlanmagan",
    "discardText": "Oynani yopsangiz, jadvalga kiritilgan o'zgarishlar bekor qilinadi.",
    "discard": "Bekor qilib yopish",
    "keepEditing": "Tahrirlashda davom etish",
    "rowSettings": {
      "none": "Qator tanlanmagan — jadvaldan qator sarlavhasini yoki katakni bosing.",
      "name": "Qator nomi",
      "type": "Turi",
      "manualHint": "Qiymatlarni jadval kataklariga kiriting (ikki marta bosing yoki Enter).",
      "sensors": "Ustunlar bo'yicha ko'rsatkichlar",
      "sensorFor": "{{column}}-ustun ko'rsatkichi",
      "rowFormula": "Barcha ustunlarga qo'llash",
      "formulaHint": "R1…Rn — qatorlar qiymati, C — ustun raqami, X — yuqoridagi qurilma qiymati. Katakdagi formula ustun.",
      "source": "Manba qatori",
      "sourceNone": "Eng yaqin qurilma qatori",
      "sourceHint": "Holat shu qator qiymatiga qarab statuslardan aniqlanadi.",
      "up": "Yuqoriga",
      "down": "Pastga",
      "delete": "Qatorni o'chirish"
    },
    "status": {
      "title": "Status chegaralari",
      "byValue": "Qurilma qiymati bo'yicha",
      "empty": "Statuslar hali qo'shilmagan",
      "range": "Chegara:",
      "rangeFrom": "{{value}} dan yuqori",
      "rangeTo": "{{value}} gacha",
      "rangeAll": "Barcha qiymatlar",
      "add": "Status qo'shish",
      "autoColor": "Katak rangini avtomatik o'zgartirish",
      "edit": "{{name}} — o'zgartirish",
      "delete": "{{name}} — o'chirish",
      "back": "Statuslarga qaytish",
      "addTitle": "Yangi status",
      "editTitle": "Statusni o'zgartirish",
      "new": "Yangi",
      "name": "Nomi",
      "namePlaceholder": "Masalan: Muhim",
      "note": "Izoh",
      "notePlaceholder": "Qisqa izoh yozing",
      "color": "Rang",
      "colors": {
        "1ECD15": "Yashil",
        "0275FF": "Ko'k",
        "F48200": "To'q sariq",
        "CA3B3D": "Qizil",
        "99A3B8": "Kulrang"
      },
      "limits": "Chegara (qurilma qiymati)",
      "from": "dan",
      "to": "gacha",
      "fromLabel": "Quyi chegara (dan)",
      "toLabel": "Yuqori chegara (gacha)",
      "addButton": "Qo'shish",
      "deleteButton": "Statusni o'chirish",
      "deleteConfirm": "Status o'chirilsinmi?",
      "deleteUsed_one": "Status {{count}} ta holat qatorida ishlatiladi. Baribir o'chirilsinmi?",
      "deleteUsed_other": "Status {{count}} ta holat qatorida ishlatiladi. Baribir o'chirilsinmi?",
      "errors": {
        "name": "Status nomini kiriting",
        "nameTaken": "Bunday nomli status mavjud",
        "number": "Chegara son bo'lishi kerak",
        "order": "\"dan\" qiymati \"gacha\" dan kichik bo'lsin",
        "overlap": "Chegara boshqa status bilan kesishadi"
      }
    }
  },
  "scene": {
    "canvas": "3D xarita",
    "globeNotice": "3D globus (CesiumJS) hozircha ulanmagan. Model, joylashuv va qurilmalar saqlanadi.",
    "needsGlobe": "3D globus ulanganda ishlaydi",
    "search": "Joy qidirish",
    "searchPlaceholder": "Koordinatalar: 41.5521, 69.9654",
    "searchGo": "Joyga o'tish",
    "searchHint": "Koordinatalarni kiriting, masalan: 41.5521, 69.9654",
    "searchRange": "Koordinatalar noto'g'ri",
    "attribution": "Xarita ulanmagan · {{lat}}, {{lng}} · {{height}} m",
    "tools": {
      "zoomIn": "Yaqinlashtirish",
      "zoomOut": "Uzoqlashtirish",
      "north": "Shimolga qaratish",
      "baseMap": "Xarita qatlami",
      "rotate": "Burish",
      "scale": "Masshtablash",
      "flyTo": "Obyektga uchish",
      "measure": "O'lchash"
    },
    "emptyTitle": "3D obyekt yuklanmagan",
    "emptyText": "Tog'on plani bilan GLB yoki glTF formatidagi 3D modelni yuklang. Keyin uni xaritada o'z joyiga moslab qo'yasiz.",
    "dropHere": "GLB faylni shu yerga tashlang",
    "or": "yoki",
    "pickFile": "Fayl tanlash",
    "formats": "Format: .glb, .gltf (ichki teksturalar bilan) · maks. 100 MB",
    "objTitle": "OBJ konvertatsiyasi hozircha mavjud emas",
    "objText": "Modelni GLB yoki glTF formatiga eksport qilib yuklang.",
    "typeError": "Bu turdagi fayl qabul qilinmaydi",
    "sizeError": "Fayl hajmi 100 MB dan oshmasin",
    "uploadError": "Modelni yuklab bo'lmadi",
    "uploaded": "3D model yuklandi",
    "loadError": "3D sahnani yuklab bo'lmadi",
    "model": "3D obyekt",
    "replace": "Modelni almashtirish",
    "delete": "Modelni o'chirish",
    "deleteTitle": "3D obyektni o'chirish",
    "deleteText": "Model sahnadan olib tashlanadi. Joylashuv va qurilmalar bog'lanishi saqlanib qoladi.",
    "status": {
      "ready": "Tayyor",
      "processing": "Qayta ishlanmoqda…",
      "failed": "Faylni o'qib bo'lmadi"
    },
    "placement": "Joylashtirish",
    "lat": "Kenglik",
    "lng": "Uzunlik",
    "height": "Balandlik",
    "heading": "Burilish",
    "scale": "Masshtab",
    "clamp": "Yer relyefiga moslash",
    "coordInvalid": "Masalan: 41.5521 yoki 41.5521° N",
    "devices": "Qurilmalar",
    "searchDevices": "Qurilma qidirish",
    "pinnedDevices": "Chizmadagi qurilmalar",
    "noDevices": "Chizmalarda qurilma bog'langan ko'rsatkich yo'q",
    "noMatches": "Hech narsa topilmadi",
    "dragging": "Sudralmoqda…",
    "dragHint": "Qurilmani 3D obyekt ustiga sudrab olib boring yoki tugmani bosing.",
    "needModel": "Avval 3D model yuklang",
    "needModelHint": "Qurilmalarni bog'lash uchun avval 3D model yuklang.",
    "attach": "Model markaziga bog'lash",
    "attached": "Modelga bog'langan",
    "attachDevice": "{{name}} — modelga bog'lash",
    "detachDevice": "{{name}} — modeldan uzish",
    "notPlaced": "Modelga bog'lanmagan",
    "showAnchor": "{{name}} — ko'rsatish",
    "hideAnchor": "{{name}} — yashirish"
  }
}
